// Robust platform detection. iPadOS 13+ reports as "MacIntel" with a desktop
// UA, so we additionally check maxTouchPoints to catch it.
export const detectPlatform = () => {
  const ua = navigator.userAgent || "";
  const isiOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (isiOS) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
};

// The wallet pass type the enrolment flow builds for a platform. Everything
// that is not Android (including desktop) gets the Apple pass.
export const passTypeForPlatform = (platform) =>
  platform === "android" ? "android" : "ios";
